import React from "react";

import PageError from "../components/template-parts/PageError";

export default () => <PageError />;
